
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

export const Descricao = styled.div`
  p {
    &:last-of-type {
      margin-bottom: 0;
    }
  }
`

export const Titulo = styled.h2`
  ${StyleGuide.tipografia.titulo2};
  margin: 0;

  @media (max-width: ${StyleGuide.mediaQuery.smallpc}) {
    font-size: 18px;
  }
  display: flex;
  justify-content: space-between;
  span {
    font-weight: bold;
    font-size: 15px;
    -webkit-text-decoration-line: underline;
    text-decoration-line: underline;
    color: #009bbf;
    cursor: pointer;
  }
`

export const PaymentMethodPix = styled.p`
  display:flex;
  align-items: center;
  svg {
    margin-right: 5px;
    stroke: #009bbf;
  }
`
